export const PAGE_SIZE = 25;

export const DisplayStatus: Record<string, string> = {
  pending_approval: "Pending approval",
  awaiting_approval: "Pending approval",
  scheduled: "Scheduled",
  in_progress: "In progress",
  processing: "Processing",
  completed: "Completed",
  partially_completed: "Completed with issues",
  failed: "Failed",
  canceled: "Canceled",
  bulk_payment_canceled: "Canceled",
  wire_import_canceled: "Canceled",
  expired: "Expired",
  approval_expired: "Expired",
  rejected_approval: "Rejected",
  unknown: "Pending",
};
